/**
 * 保险相关
 * 2018.8.6
 */
import GlobalConfig from '../config/global';
import ApiPort from '../config/api-port';
import HttpAxios from './http-axios';
import {handleError, handleResponse} from '../lib/common';

const junziqianApi = GlobalConfig.domain.junziqianApi;

export default {

  /**
   * 获取保险详情,查看
   * @param preservationId     保全id
   * @returns {Promise<T>}
   */
  detail(preservationId) {
    let url = junziqianApi + ApiPort.insuranceController.insureDetail;

    return HttpAxios.post(url, {preservationId: preservationId})
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 发起购买保险订单
   * @param signNo        签署编号
   * @param insureYear    购买年数
   * @param returnURL     支付后跳转地址
   * @param ifMobile      0默认
   * @returns {PromiseLike<T>}
   */
  order: function({signNo, insureYear, returnURL, ifMobile, pay}) {
    let url = junziqianApi + ApiPort.insuranceController.orderInsurance;
    let jsonData = {signNo: signNo, insureYear: insureYear, returnURL: returnURL, ifMobile: ifMobile || 0, pay: pay};

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 通过signNo 查找相关信息显示购买保险商品信息
   * @param signNo      签署编号
   * @returns {Promise<T>}
   */
  productInfo(signNo) {
    let url = junziqianApi + ApiPort.insuranceController.productInfo;
    let jsonData = {signNo: signNo};

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },
};



// WEBPACK FOOTER //
// ./assets/js/http-serve/insuranceController.js